import apiAddress from "./apiAddress";
const image = `https://puregroveappimages.s3.ap-south-1.amazonaws.com/images`;
export default image;
